import { render, staticRenderFns } from "./ShareBrainstormingCourse.vue?vue&type=template&id=79e20514"
import script from "./ShareBrainstormingCourse.vue?vue&type=script&lang=js"
export * from "./ShareBrainstormingCourse.vue?vue&type=script&lang=js"
import style0 from "./ShareBrainstormingCourse.vue?vue&type=style&index=0&id=79e20514&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports